import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=1eb563b0&"
import script from "./ProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectDetails.vue"
export default component.exports